import React, { useEffect, useState } from "react";
import { generateClient } from "aws-amplify/api";
import { listSlumSoccerEvents } from "../graphql/queries";
import { EventCard } from "../components/EventCard";

const client = generateClient();

export function Events(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const fetchData = async () => {
    let pendingData = await client.graphql({
      query: listSlumSoccerEvents,
    });
    
    // Sort the events by date in descending order (most recent first)
    const sortedEvents = pendingData["data"]["listSlumSoccerEvents"].items.sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });
    
    setData(sortedEvents);
  };

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 animate__animated animate__bounceInUp">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-orange-500 relative inline-block -mt-5">
            Upcoming Events
            <div className="h-1 w-full bg-orange-500 mt-2"></div>
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">Our Events</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.map((event) => (
            <EventCard key={event.eventId} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
}